import mutations from './drugSelectDialog.mutations'
import actions from './drugSelectDialog.actions'
import getters from './drugSelectDialog.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
